// extracted by mini-css-extract-plugin
export var messageSideLeft = "_of-1";
export var messageSideRight = "_of-2";
export var subscribeToBackInStockBubbleContainer = "_of-0";